import Echo from 'laravel-echo';
export const socketConnection = () => {
	window.Pusher = require('pusher-js');
	return new Echo({
		broadcaster: 'pusher',
		key: process.env.REACT_APP_WEBSOCKETS_KEY,
		wsHost: process.env.REACT_APP_WEBSOCKETS_SERVER,
		wsPort: 6001,
		wssPort: 6001,
		cluster: 'mt1',
		forceTLS: false,
		enabledTransports: ['ws', 'wss'],
		disableStats: true,
	});
};
